import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-legal-protection-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_459_2028)">
        <path
          d="M12.8181 14.517L15.3631 11.972L17.1151 12.442C17.3814 12.513 17.6617 12.5128 17.9279 12.4413C18.1941 12.3698 18.4368 12.2295 18.6317 12.0346C18.8266 11.8397 18.9668 11.597 19.0383 11.3308C19.1098 11.0646 19.1101 10.7843 19.0391 10.518L18.5691 8.76597L19.3531 7.98197L21.1051 8.45197C21.3714 8.52332 21.6519 8.52331 21.9182 8.45193C22.1846 8.38055 22.4274 8.24033 22.6224 8.04534C22.8174 7.85036 22.9576 7.60748 23.029 7.34113C23.1004 7.07478 23.1004 6.79433 23.0291 6.52797L22.5601 4.77597C23.0019 4.33399 23.2501 3.73459 23.25 3.10962C23.2499 2.48466 23.0015 1.88532 22.5596 1.44347C22.3407 1.22469 22.0809 1.05116 21.795 0.932778C21.5091 0.814399 21.2026 0.753494 20.8932 0.75354C20.2682 0.753634 19.6689 1.00199 19.2271 1.44397L9.48605 11.185C8.14364 10.6158 6.64506 10.5313 5.24715 10.9458C3.84923 11.3604 2.63902 12.2482 1.82392 13.4572C1.00882 14.6662 0.639584 16.121 0.779487 17.5724C0.919389 19.0237 1.55972 20.3813 2.59075 21.4123C3.62177 22.4433 4.97929 23.0836 6.43065 23.2235C7.88201 23.3634 9.33684 22.9942 10.5458 22.1791C11.7548 21.364 12.6426 20.1538 13.0572 18.7559C13.4718 17.358 13.3872 15.8594 12.8181 14.517Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.92207 19.652C6.78971 19.652 7.49307 18.9486 7.49307 18.081C7.49307 17.2134 6.78971 16.51 5.92207 16.51C5.05443 16.51 4.35107 17.2134 4.35107 18.081C4.35107 18.9486 5.05443 19.652 5.92207 19.652Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_459_2028">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class LegalProtectionInsuranceIconComponent extends BaseIconComponent {}
